import { toEnglishNumber, toPersianNumber, } from "@/hooks/useThousandsSeparator";
import AdapterMomentJalali from "@/shared/components/common/datePeacker";
import { SvgCompelete } from "@/shared/components/common/icons";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid, TextField } from "@mui/material";
interface AddUserModalProps{
    setDataForm: any;
    dataForm: any;
    success: boolean;
}
/**
 * AddUserModal
 *
 * کامپوننت مربوط به ثبت کاربر در سازمان مشتریان. در صورتی که عملیات با موفقیت انجام شود،
 * پیام تایید نمایش داده می‌شود. در حالت عادی، فرم دریافت اطلاعات شامل کد ملی، شماره تماس
 * و تاریخ تولد ارائه می‌گردد. این کامپوننت شامل کنترل و نرمال‌سازی ورودی‌های عددی نیز می‌باشد.
 *
 * @param setDataForm تابع به‌روزرسانی داده‌های فرم
 * @param dataForm شیء شامل داده‌های فرم
 * @param success وضعیت موفقیت ثبت کاربر
 * @returns JSX.Element
 */
const AddUserModal = ({setDataForm,dataForm,success,}: AddUserModalProps) => {
  
  const handleChangeNumberId = (e: React.ChangeEvent<HTMLInputElement>) => {
    const englishNumber = toEnglishNumber(e.target.value);
    const rawValue = englishNumber.replace(/[^0-9]/g, "");
    if (rawValue.length <= 10) {
      setDataForm((prev: any) => ({
        ...prev,
        NID: rawValue,
      }));
    }
  };

  const handleChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const englishNumber = toEnglishNumber(e.target.value);
    const rawValue = englishNumber.replace(/[^0-9]/g, "");
    setDataForm((prev: any) => ({
      ...prev,
      phoneNumber: rawValue,
    }));
  };

  const handleChangeDate = (date: string) => {
    setDataForm((prev: any) => ({
      ...prev,
      birthday: date,
    }));
  };

  return (
    <>
      {success ? (
        <StackKit justifyContent="center" alignItems="center">
          <StackKit justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
            <SvgCompelete />
          </StackKit>
          <TypoGraphyKit>
            پذیرنده گرامی؛
            <br />
            کاربر مورد نظر با موفقیت در سازمان مشتریان شما ثبت شد.
          </TypoGraphyKit>
        </StackKit>
      ) : (
        <form style={{ width: "100%" }}>
          <StackKit sx={{ width: "100%", gap: 3 }}>
            <TypoGraphyKit variant="body1">
              پذیرنده گرامی؛ این بخش مخصوص کاربرانی میباشد که از قبل در سامانه
              پولی پی ثبت نام شده‌اند. لطفا برای افزودن کاربر به این سازمان؛
              شماره تماس و کد ملی کاربر را وارد نمایید.
            </TypoGraphyKit>

            <Grid container spacing={2}>
              {/* کد ملی */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <TypoGraphyKit variant="body1">کد ملی کاربر</TypoGraphyKit>
                <TextField fullWidth value={dataForm.NID ? toPersianNumber(dataForm.NID) : ""} onChange={handleChangeNumberId} placeholder="کد ملی را وارد کنید" inputProps={{ maxLength: 10 }}/>
              </Grid>

              {/* شماره تماس */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <TypoGraphyKit variant="body1">شماره تماس کاربر</TypoGraphyKit>
                <TextField fullWidth value={dataForm.phoneNumber ? toPersianNumber(dataForm.phoneNumber) : ""} onChange={handleChangePhoneNumber} placeholder="شماره تماس را وارد کنید" inputProps={{ maxLength: 11 }}/>
              </Grid>

              {/* تاریخ تولد */}
              <Grid size={{ xs: 12, sm: 6 }}>
                <TypoGraphyKit variant="body1">تاریخ تولد</TypoGraphyKit>
                <AdapterMomentJalali sx={{width: "100%",display: "flex",justifyContent: "end",height: "50px",}} handleChange={handleChangeDate}/>
              </Grid>
            </Grid>
          </StackKit>
        </form>
      )}
    </>
  );
};

export default AddUserModal;